import { usePublicLoyalty } from "@/hooks/usePublicLoyalty";

const money = (value) => `₹${new Intl.NumberFormat("en-IN").format(Number(value || 0))}`;

export default function LoyaltyBenefits() {
  const { config, loading } = usePublicLoyalty();
  const tiers = (config?.tier_rules || []).filter((tier) => tier.is_active !== false);
  const rows = [
    { label: "Earn rate", value: (tier) => `${Number(tier.earn_multiplier || 1)}x` },
    { label: "Welcome bonus", value: (tier) => `${Number(tier.welcome_bonus || 0)} pts` },
    { label: "Birthday bonus", value: (tier) => `${Number(tier.birthday_bonus || 0)} pts` },
    { label: "Anniversary bonus", value: (tier) => `${Number(tier.anniversary_bonus || 0)} pts` },
    { label: "Tier qualification", value: (tier) => money(tier.min_lifetime_spend) },
    { label: "Point validity", value: (tier) => `${tier.point_expiry_override_days || config?.point_expiry_days || 0} days` },
  ];
  return (
    <div className="max-w-[1300px] mx-auto px-6 lg:px-12 py-20" data-testid="page-benefits">
      <div className="text-[11px] uppercase tracking-[0.3em] kazo-text-burgundy mb-4">THE BENEFITS</div>
      <h1 className="editorial-headline text-5xl lg:text-7xl mb-12">Compare<br /><em className="font-light">your tier.</em></h1>
      {loading ? <div data-testid="benefits-loading">Loading benefits…</div> : tiers.length === 0 ? <p className="text-neutral-600" data-testid="benefits-empty">Programme benefits will appear here when the active loyalty tiers are published.</p> : (
        <div className="overflow-x-auto bg-white border border-black/10"><table className="data-table min-w-[720px]"><thead><tr><th className="!bg-black !text-white">FEATURE</th>{tiers.map((tier) => <th key={tier.tier} className="!bg-black !text-white text-center">{tier.name || tier.tier}</th>)}</tr></thead><tbody>{rows.map((row) => <tr key={row.label}><td className="font-medium">{row.label}</td>{tiers.map((tier) => <td key={tier.tier} className="text-center">{row.value(tier)}</td>)}</tr>)}</tbody></table></div>
      )}
    </div>
  );
}